/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} BoldInputs */



/**
* | output |
* | --- |
* | "Bold" |
*
* @param {BoldInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const bold = /** @type {((inputs?: BoldInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<BoldInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Gras")
	if (locale === "de") return /** @type {LocalizedString} */ ("Deutlich")
	if (locale === "it") return /** @type {LocalizedString} */ ("Grassetto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Смелый")
	if (locale === "es") return /** @type {LocalizedString} */ ("Atrevido")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("大胆的")
	if (locale === "ja") return /** @type {LocalizedString} */ ("大胆な")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बोल्ड")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Audacioso")
	return /** @type {LocalizedString} */ ("Bold")
});